const CustomFieldType = {
  Boolean: 'BOOLEAN',
  Date: 'DATE',
  DateTime: 'DATE_TIME',
  Select: 'SELECT',
  Text: 'TEXT'
}

export default CustomFieldType
